module.exports = __webpack_public_path__ + "img/SC6-Future_income_needs_2.116cf5e5.png";